export const usStates = {
    "Northern Mariana Islands": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Northern Mariana Islands",
      "City": "",
      "CityCode": "",
      "Lat": "15.1",
      "Lon": "145.67",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Hawaii": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Hawaii",
      "City": "",
      "CityCode": "",
      "Lat": "21.09",
      "Lon": "-157.5",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Colorado": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Colorado",
      "City": "",
      "CityCode": "",
      "Lat": "39.06",
      "Lon": "-105.31",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Arizona": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Arizona",
      "City": "",
      "CityCode": "",
      "Lat": "33.73",
      "Lon": "-111.43",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Iowa": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Iowa",
      "City": "",
      "CityCode": "",
      "Lat": "42.01",
      "Lon": "-93.21",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "North Carolina": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "North Carolina",
      "City": "",
      "CityCode": "",
      "Lat": "35.63",
      "Lon": "-79.81",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Wyoming": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Wyoming",
      "City": "",
      "CityCode": "",
      "Lat": "42.76",
      "Lon": "-107.3",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Mississippi": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Mississippi",
      "City": "",
      "CityCode": "",
      "Lat": "32.74",
      "Lon": "-89.68",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Pennsylvania": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Pennsylvania",
      "City": "",
      "CityCode": "",
      "Lat": "40.59",
      "Lon": "-77.21",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Alaska": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Alaska",
      "City": "",
      "CityCode": "",
      "Lat": "61.37",
      "Lon": "-152.4",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Kansas": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Kansas",
      "City": "",
      "CityCode": "",
      "Lat": "38.53",
      "Lon": "-96.73",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "District of Columbia": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "District of Columbia",
      "City": "",
      "CityCode": "",
      "Lat": "38.9",
      "Lon": "-77.03",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "California": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "California",
      "City": "",
      "CityCode": "",
      "Lat": "36.12",
      "Lon": "-119.68",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "West Virginia": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "West Virginia",
      "City": "",
      "CityCode": "",
      "Lat": "38.49",
      "Lon": "-80.95",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Arkansas": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Arkansas",
      "City": "",
      "CityCode": "",
      "Lat": "34.97",
      "Lon": "-92.37",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Montana": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Montana",
      "City": "",
      "CityCode": "",
      "Lat": "46.92",
      "Lon": "-110.45",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Guam": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Guam",
      "City": "",
      "CityCode": "",
      "Lat": "13.44",
      "Lon": "144.79",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Delaware": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Delaware",
      "City": "",
      "CityCode": "",
      "Lat": "39.32",
      "Lon": "-75.51",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Louisiana": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Louisiana",
      "City": "",
      "CityCode": "",
      "Lat": "31.17",
      "Lon": "-91.87",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Nevada": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Nevada",
      "City": "",
      "CityCode": "",
      "Lat": "38.31",
      "Lon": "-117.06",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "New Mexico": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "New Mexico",
      "City": "",
      "CityCode": "",
      "Lat": "34.84",
      "Lon": "-106.25",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Virginia": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Virginia",
      "City": "",
      "CityCode": "",
      "Lat": "37.77",
      "Lon": "-78.17",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "South Dakota": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "South Dakota",
      "City": "",
      "CityCode": "",
      "Lat": "44.3",
      "Lon": "-99.44",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Utah": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Utah",
      "City": "",
      "CityCode": "",
      "Lat": "40.15",
      "Lon": "-111.86",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Connecticut": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Connecticut",
      "City": "",
      "CityCode": "",
      "Lat": "41.6",
      "Lon": "-72.76",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Rhode Island": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Rhode Island",
      "City": "",
      "CityCode": "",
      "Lat": "41.68",
      "Lon": "-71.51",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Oklahoma": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Oklahoma",
      "City": "",
      "CityCode": "",
      "Lat": "35.57",
      "Lon": "-96.93",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Ohio": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Ohio",
      "City": "",
      "CityCode": "",
      "Lat": "40.39",
      "Lon": "-82.76",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Tennessee": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Tennessee",
      "City": "",
      "CityCode": "",
      "Lat": "35.75",
      "Lon": "-86.69",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Kentucky": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Kentucky",
      "City": "",
      "CityCode": "",
      "Lat": "37.67",
      "Lon": "-84.67",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Grand Princess": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Grand Princess",
      "City": "",
      "CityCode": "",
      "Lat": "37.65",
      "Lon": "-122.67",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Puerto Rico": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Puerto Rico",
      "City": "",
      "CityCode": "",
      "Lat": "18.22",
      "Lon": "-66.59",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Wisconsin": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Wisconsin",
      "City": "",
      "CityCode": "",
      "Lat": "44.27",
      "Lon": "-89.62",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "North Dakota": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "North Dakota",
      "City": "",
      "CityCode": "",
      "Lat": "47.53",
      "Lon": "-99.78",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Washington": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Washington",
      "City": "",
      "CityCode": "",
      "Lat": "47.4",
      "Lon": "-121.49",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Indiana": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Indiana",
      "City": "",
      "CityCode": "",
      "Lat": "39.85",
      "Lon": "-86.26",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "New Hampshire": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "New Hampshire",
      "City": "",
      "CityCode": "",
      "Lat": "43.45",
      "Lon": "-71.56",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Maine": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Maine",
      "City": "",
      "CityCode": "",
      "Lat": "44.69",
      "Lon": "-69.38",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Georgia": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Georgia",
      "City": "",
      "CityCode": "",
      "Lat": "33.04",
      "Lon": "-83.64",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Illinois": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Illinois",
      "City": "",
      "CityCode": "",
      "Lat": "40.35",
      "Lon": "-88.99",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Vermont": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Vermont",
      "City": "",
      "CityCode": "",
      "Lat": "44.05",
      "Lon": "-72.71",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Idaho": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Idaho",
      "City": "",
      "CityCode": "",
      "Lat": "44.24",
      "Lon": "-114.48",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "New York": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "New York",
      "City": "",
      "CityCode": "",
      "Lat": "42.17",
      "Lon": "-74.95",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Virgin Islands": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Virgin Islands",
      "City": "",
      "CityCode": "",
      "Lat": "18.34",
      "Lon": "-64.9",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Maryland": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Maryland",
      "City": "",
      "CityCode": "",
      "Lat": "39.06",
      "Lon": "-76.8",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Oregon": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Oregon",
      "City": "",
      "CityCode": "",
      "Lat": "44.57",
      "Lon": "-122.07",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Alabama": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Alabama",
      "City": "",
      "CityCode": "",
      "Lat": "32.32",
      "Lon": "-86.9",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Texas": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Texas",
      "City": "",
      "CityCode": "",
      "Lat": "31.05",
      "Lon": "-97.56",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Missouri": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Missouri",
      "City": "",
      "CityCode": "",
      "Lat": "38.46",
      "Lon": "-92.29",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "New Jersey": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "New Jersey",
      "City": "",
      "CityCode": "",
      "Lat": "40.3",
      "Lon": "-74.52",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Minnesota": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Minnesota",
      "City": "",
      "CityCode": "",
      "Lat": "45.69",
      "Lon": "-93.9",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Nebraska": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Nebraska",
      "City": "",
      "CityCode": "",
      "Lat": "41.13",
      "Lon": "-98.27",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Massachusetts": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Massachusetts",
      "City": "",
      "CityCode": "",
      "Lat": "42.23",
      "Lon": "-71.53",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Diamond Princess": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Diamond Princess",
      "City": "",
      "CityCode": "",
      "Lat": "35.44",
      "Lon": "139.64",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "South Carolina": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "South Carolina",
      "City": "",
      "CityCode": "",
      "Lat": "33.86",
      "Lon": "-80.95",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Michigan": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Michigan",
      "City": "",
      "CityCode": "",
      "Lat": "43.33",
      "Lon": "-84.54",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    },
    "Florida": {
      "Country": "United States of America",
      "CountryCode": "US",
      "Province": "Florida",
      "City": "",
      "CityCode": "",
      "Lat": "27.77",
      "Lon": "-81.69",
      "Confirmed": 0,
      "Deaths": 0,
      "Recovered": 0,
      "Active": 0,
      "Date": "2020-05-06T00:00:00Z"
    }
  }
  